__turbopack_context__.v({
  "compact": "account-menu-item-module-sass-module__0t0dfa__compact",
  "item": "account-menu-item-module-sass-module__0t0dfa__item",
  "itemActive": "account-menu-item-module-sass-module__0t0dfa__itemActive",
  "linkItem": "account-menu-item-module-sass-module__0t0dfa__linkItem",
  "secondary": "account-menu-item-module-sass-module__0t0dfa__secondary",
  "tab": "account-menu-item-module-sass-module__0t0dfa__tab",
});
